
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeNotificacion: null,
    notificaciones: [],
    isLoadingNotificacion: false,
    totalNotificacion: 0,




    infoActiveNotificacion: async(info) => {
        set({ activeNotificacion: info });
    },
    
});







export const useNotificacionesStore = create()(
    devtools(
        storeApi
    )
)
